import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import './css/base.css';

/* subpages */
import Intro from './sections/intro';
import MainPage from './sections/mainpage';
import B2BRegistrationForm from './sections/b2bregistrationform';
import B2BRegistrationDone from './sections/b2bregistrationdone';

/* redirects */
import ExternalRedirect from './hooks/externalRedirect';

const root = ReactDOM.createRoot(document.getElementById('root'));

/* 
useful imports
----------------------------------------
import Settings from "../settings.json";
import useDictionary from '../hooks/useDictionary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faFacebook, faTiktok } from '@fortawesome/free-brands-svg-icons'

useful components
-----------------------------------------
<Link to="negativ" title="Idź do głównej!" class="WelcomeLink" />
<FontAwesomeIcon icon={faFacebook} style={{ fontSize: '16px' }} />

useful methods
------------------------------------------
<nav className={`main-navbar ${menuVisible ? "main-navbar-visible" : "main-navbar-hidden"}`}>
*/

const handleOnSuccess = (x, y) => {
  //do nothing for a while
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Intro />} />
        <Route path="/:lang" element={<Intro />} />
        <Route path="/:lang/negativ" element={<MainPage />} />
        <Route path="/:lang/b2b-reg-form" element={<B2BRegistrationForm onSuccess={handleOnSuccess} />} />
        <Route path="/:lang/b2b-reg-form/done" element={<B2BRegistrationDone />} />
        <Route path="/:lang/product/:id" element={ <ExternalRedirect template="https://store.negativbrand.com/:lang/product/:id/ref_landingpage.html" /> } />
        <Route path="/social/instagram" element={<ExternalRedirect template="https://www.instagram.com/negativ_official/" />} />
        <Route path="/social/tiktok" element={<ExternalRedirect template="https://www.tiktok.com/@negativofficial/" />} />
        <Route path="/social/facebook" element={<ExternalRedirect template="https://www.facebook.com/NegativFashion" />} />
        <Route path="/social/whatsapp" element={<ExternalRedirect template="https://wa.me/48792707070/" />} />
        <Route path="/returns" element={<ExternalRedirect template="https://store.negativbrand.com/en/returns" />} />
        <Route path="/zwroty" element={<ExternalRedirect template="https://store.negativbrand.com/pl/returns" />} />
        <Route path="/client" element={<ExternalRedirect template="https://store.negativbrand.com/en/customer" />} />
        <Route path="/signin" element={<ExternalRedirect template="https://store.negativbrand.com/pl/customer" />} />
        <Route path="/store" element={<ExternalRedirect template="https://store.negativbrand.com/" />} />
        <Route path="/b2b" element={<ExternalRedirect template="https://b2b.negativbrand.com/" />} />

        <Route path="/:lang/golden-hairclip" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/product/28272131/akcesoria_negativ.html" />} />

        <Route path="/:lang/b2b-platform" element={<ExternalRedirect template="https://b2b.negativbrand.com/:lang/" />} />
        <Route path="/:lang/contact" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/read/contact.html" />} />
        <Route path="/:lang/store" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/mainpage/" />} />

        <Route path="/:lang/catsuits" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/show/category/17/kombinezony.html" />} />
        <Route path="/:lang/leggings" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/mainpage/1/filters:+category=3+subcategory=54/najlepsze_legginsy.html" />} />
        <Route path="/:lang/leather-jackets" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/show/subcategory/39/kurtki_skorzane.html" />} />
        <Route path="/:lang/track-suits" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/show/category/25/bluzy.html" />} />
        <Route path="/:lang/shoes" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/show/category/4/buty.html" />} />
        <Route path="/:lang/tops-and-bodysuits" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/mainpage/1/filters:+category=5++category=22/body_bluzki.html" />} />
        <Route path="/:lang/giftcards" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/giftcards/karty_podarunkowe.html" />} />
        <Route path="/:lang/customer" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/customer" />} />
        <Route path="/:lang/returns" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/returns" />} />

        <Route path="/:lang/delivery" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/read/delivery_services.html" />} />
        <Route path="/:lang/sms-service" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/sms" />} />
        <Route path="/:lang/terms-and-conditions" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/read/terms_and_conditions.html" />} />
        <Route path="/:lang/rodo" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/read/rodo.html" />} />
        <Route path="/:lang/cookies" element={<ExternalRedirect template="https://store.negativbrand.com/:lang/read/cookies.html" />} />

        <Route path="/pay/:id" element={ <ExternalRedirect template="https://store.negativbrand.com/pl/shortcut/:id" /> } />
        <Route path="/trk/:id" element={ <ExternalRedirect template="https://store.negativbrand.com/pl/shortcut/:id" /> } />
        <Route path="/socialmedia/:id" element={ <ExternalRedirect template="https://store.negativbrand.com/pl/product/:id/ref_socialmedia.html" /> } />
        <Route path="/product/:id" element={ <ExternalRedirect template="https://store.negativbrand.com/pl/product/:id/ref_landingpage.html" /> } />

      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);